module.exports = __webpack_public_path__ + "01d990b83ff61525382e33fd505404af.png";